module.exports = "pegasus/assets/themelp1/app/104.png";